import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { currentBudgetSelector } from "../currentBudgetSelector";

export const currentBudgetPeriodSelector = createDraftSafeSelector(
  [currentBudgetSelector],
  (budget) => budget?.body?.period,
);
